import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import classnames from 'classnames';

import { ButtonWithLoader, OroLoader, OroLoaderInline } from '../../../core';
import { onboardingService } from '../../services/onboarding';
import middlewareConstants  from "../../../shared/middleware-constant";
import { middlewareService } from "../../../shared/service";

import { store } from '../../../store';
import { setKycDetails, setOnboardingKycDetails } from "../../../actions";

import PersonalDetailsForm from './PersonalDetailsForm';
import ResidenceDetailsForm from './ResidenceDetailsForm';
import MiscDetailsForm from './MiscDetailsForm';
import UploadDocs from './UploadDocs';
import { Helpers } from "../onboarding/bse/halper/index";

import {
  Row,
  Col,
  Card,
  CardBody,
  Media,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  Button
} from 'reactstrap';
import { kycVerificationStatus } from '../../../constants/onboarding';
import { KycVerificationStatus } from '../../../constants';

class BseKycIncomplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: '',
      kycDetails: {},
      personalDetails: {},
      residence: {},
      misc: {},
      childModal: false,
      goToDocs: false
    };

    this.setDob = this.setDob.bind(this);
    this.setKycDetails = this.setKycDetails.bind(this);
    this.submitKycDetails = this.submitKycDetails.bind(this);
    this.setCurrentStep = this.setCurrentStep.bind(this);
    this.areAllStepsCompleted = this.areAllStepsCompleted.bind(this);
  }

  //Format the redux
  componentDidMount() {
    var kycData = {};
    let isFromUserState = store.getState().onboarding && store.getState().onboarding.addPan && store.getState().onboarding.addPan.fromUserState
    if (isFromUserState) {
      this.initialiseUserState();
      return;
    }
    let bseData = store.getState().bse && store.getState().bse.hasBseAccount; 
    let bseVsMfu = Helpers.isCpdForMfuOrBse(store.getState().user.userDetails && store.getState().user.userDetails.cpd[0].CPD, bseData);

    this.setState({
      hasCPDEntry : store.getState().user.userDetails && store.getState().user.userDetails.cpd[0].CPD && store.getState().user.userDetails.cpd[0].CPD.length,
      isBseUser: store.getState().bse && store.getState().bse.hasBseAccount,
      bseVsMfu: bseVsMfu
    });
    if (store.getState().onboarding.kycDetails && store.getState().onboarding.kycDetails.kycData) {
      kycData = store.getState().onboarding.kycDetails.kycData;
      this.initKycDetails(kycData);
    } else {
      var dob = '';
      var validPans = store.getState().user.validPansList;
      validPans.map(panDetails => {
        if (panDetails.pan === this.props.pan) {
          dob = panDetails.dob;
          if (dob) {
            dob = dob.replace(/-/g, '/');
            dob = dob.replace(/\s/g, '/');
          }
        }
      });

      onboardingService.addPan(dob, this.props.pan, '', '', false)
        .then(kycCheck => {
          if (kycCheck.status && kycCheck.status.response === 'success') {
            this.setState({
              submitting: false
            });

            store.dispatch(setOnboardingKycDetails({
              kycVerificationStatus: kycCheck.status.message,
              kycData: kycCheck.data
            }));

            kycData = store.getState().onboarding.kycDetails.kycData;
            this.initKycDetails(kycData);
          } else {
            //there is an error. display it.
            this.setState({
              submitting: false,
              errors: {
                general: kycCheck.status.userMessage
              }
            });
          }
        });
    }
  }

  initialiseUserState = () => {
    let kycData = store.getState().onboarding && store.getState().onboarding.kycDetails && store.getState().onboarding.kycDetails.kycPartial ? store.getState().onboarding.kycDetails.kycPartial : {}     
    let dob = store.getState().onboarding && store.getState().onboarding.addPan ? store.getState().onboarding.addPan.dob : ""
    
    let userState = store.getState().userState
    if (userState.nextUserState === "pandobSubmitted" || userState.nextUserState === "kycFormPartiallyFilled") {
      store.dispatch(setOnboardingKycDetails({
        kycVerificationStatus: userState.userStateArr && userState.userStateArr.isKyc ? KycVerificationStatus.KYC_COMPLETE : kycVerificationStatus.KYC_INCOMPLETE ,
        kycData: kycData,
        kycPartial: kycData
      }));
      this.initKycDetails(kycData);
      return;
    }
    this.setState({
      isLoading:true
    })

    onboardingService.addPan(dob, this.props.pan, '', '', false, true)
        .then(kycCheck => {
          if(kycCheck.status && kycCheck.status.response === 'success') {
            this.setState({
             submitting: false
            });
            store.dispatch(setOnboardingKycDetails({
              kycVerificationStatus: kycCheck.status.message,
              kycData: kycData,
              kycPartial: kycData
            }));
            this.initKycDetails(kycData);
          } else {
            this.initKycDetails(kycData);
            this.setState({
              submitting: false, 
              isLoading: false,
              errors: {
                general: kycCheck.status.userMessage
              }
            });
          }
        });
  }

  initKycDetails(kycData) {
    var personalDetails = {
      gender: kycData.gender,
      nationality: kycData.nationality,
      cob: kycData.cob,
      name: kycData.name,
      firstName: kycData.name && kycData.name.split(" ") ? kycData.name.split(" ")[0] : "",
      lastName: kycData.name && kycData.name.split(" ") ? kycData.name.split(" ")[1] : "",
      fName: kycData.fName,
      pob: kycData.pob,
      mobile: kycData.mobile,
      isSubmitted: kycData.personalDetails ? kycData.personalDetails.isSubmitted: false
    }

    var residence = {
      indianTaxRes: kycData.indianTaxRes,
      residentialStatus: kycData.residentialStatus,
      country: kycData.country,
      address1: kycData.address1,
      address2: kycData.address2,
      address3: kycData.address3,
      addressProof: kycData.addressProof,
      city: kycData.city,
      pincode: kycData.pincode,
      state: kycData.state,
      perAddress1: kycData.perAddress1,
      perAddress2: kycData.perAddress2,
      perAddress3: kycData.perAddress3,
      perAddressProof: kycData.perAddressProof,
      perCity: kycData.perCity,
      perPincode: kycData.perPincode,
      showPermanentDetailsForm: kycData.showPermanentDetailsForm,
      perState: kycData.perState,
      perCountry: kycData.perCountry,
      isSubmitted: kycData.residence ? kycData.residence.isSubmitted : false
    }

    var misc = {
      income: kycData.income,
      occupation: kycData.occupation,
      politicallyExposed: kycData.politicallyExposed,
      martialStatus: kycData.martialStatus,
      isSubmitted: kycData.misc ? kycData.misc.isSubmitted: false
    }

    this.setState({
      kycDetails: kycData,
      personalDetails: personalDetails,
      residence: residence,
      misc: misc,
      isLoading: false,
      currentStep: kycData.step,
      personalDetailsDone: kycData.personalDetailsDone,
      residenceDetailsDone: kycData.residenceDetailsDone
    });
  }

  setDob(date) {
    this.setState({
      dob: date,
      formattedDob: date.format("MMMM D, YYYY"),
      personalDetails: {},
      residence: {},
      misc: {},
      docs: {}
    });
  }

  setKycDetails(step, details, shouldMoveNext) {
    var kycDetails = this.state.kycDetails;
    var stateDetails = {};
    stateDetails[step] = details;
    Object.assign(kycDetails, details);
    store.dispatch(setKycDetails(kycDetails));

    let data = store.getState().onboarding.kycDetails;
    var nextStep = '';
    switch (step) {
      case 'personalDetails':
        if (shouldMoveNext) {
          details.isSubmitted = true;
        }
        this.setState({
          isSubmittingPersonal: true,
          personalDetails: details,
          kycDetails: kycDetails,
          personalDetailsDone : true,
          currentStep: shouldMoveNext ? 'residence' : this.state.currentStep
        }, () => {
          this.saveKycData("residence",true,false,false)
          if (shouldMoveNext) {
            this.submitKycDetails(step, 'residence');
          } else {
            return toast.success("Saved!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: true
            });
          }
        });
        break;

      case 'residence':
        if (shouldMoveNext) {
          details.isSubmitted = true;
        }
        this.setState({
          isSubmittingResidence: true,
          residence: details,
          kycDetails: kycDetails,
          residenceDetailsDone : true,
          currentStep: shouldMoveNext ? 'misc' : this.state.currentStep
        }, () => {
          this.saveKycData("misc",true,true,false)
          if (shouldMoveNext) {
            this.submitKycDetails(step, 'misc');
          } else {
            return toast.success("Saved!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: true
            });
          }
        });
        break;

      case 'misc':
        
        if (shouldMoveNext) {
          details.isSubmitted = true;
        }
        if(!this.state.personalDetailsDone || !this.state.residenceDetailsDone){
          this.setState({
            misc: details,
            kycDetails: kycDetails,
          }, () => {
            this.saveKycData("docs",true,true,true)
            this.controlChildModal();
          return toast.error("please fill all details", {
            position: toast.POSITION.TOP_RIGHT,
              autoClose: true
          });
        })
        } else {
        this.setState({
          isSubmittingMisc: true,
          misc: details,
          kycDetails: kycDetails,
          currentStep: shouldMoveNext ? 'docs' : this.state.currentStep
        }, () => {
          this.saveKycData("docs",true,true,true);
          this.submitKycDetails(step, 'docs');
        });
        break;
      }
    }
  }

  saveKycData = (step,personalDetailsDone,residenceDetailsDone,miscdone) => {
    console.log("user state:pan check", step, personalDetailsDone, residenceDetailsDone,miscdone, store.getState().onboarding && store.getState().onboarding.addPan ? store.getState().onboarding.addPan.dob : "",)
    let kycDetails = this.state.kycDetails;
    kycDetails["personalDetailsDone"] = true;
    kycDetails["residenceDetailsDone"] = residenceDetailsDone;
    
    let payload = {
      "isAjax": "true",
      "source": "ios",
      "Platform": "web",
      dob: store.getState().onboarding && store.getState().onboarding.addPan ? store.getState().onboarding.addPan.dob : "",
      pan: this.props.pan,
      email: store.getState().user.userDetails.info.email,
      step: step,
      ...kycDetails,
      personalDetails: { isSubmitted: personalDetailsDone} ,
      residence: {isSubmitted: residenceDetailsDone},
      misc: {isSubmitted:miscdone},
    }
    let _url = "/cvlKyc/saveKycForm";
    let requestOptions = middlewareConstants.requestWithCredentialsJsonBSE;
    requestOptions.body = JSON.stringify(payload);

    middlewareService.servicePost(process.env.REACT_APP_API_URL+ _url, requestOptions)
    .then(response => {
    })
  }

  submitKycDetails(currentStep, nextStep) {
    var hasCPD = store.getState().user.userDetails && store.getState().user.userDetails.cpd[0].CPD && store.getState().user.userDetails.cpd[0].CPD.length
    var isBseUser = store.getState().bse && store.getState().bse.hasBseAccount;
    let bseVsMfu = Helpers.isCpdForMfuOrBse(store.getState().user.userDetails && store.getState().user.userDetails.cpd[0].CPD, isBseUser);
    let isFromUserState = store.getState().onboarding && store.getState().onboarding.addPan && store.getState().onboarding.addPan.fromUserState
    let bankAdded = store.getState().userState  && store.getState().userState.nextUserState 
    
    if (nextStep === 'docs') {
      if (isBseUser || !hasCPD || bseVsMfu.isBseUser) {
        let kycDetails = this.state.kycDetails;
        kycDetails["misc"] = {...kycDetails.misc,isSubmitted: true}
        kycDetails["personalDetails"] = {...kycDetails.personalDetails,isSubmitted: true}
        kycDetails["residence"] = {...kycDetails.residence,isSubmitted: true}
        kycDetails.personalDetailsDone = true
        kycDetails.residenceDetailsDone = true
        let payload = kycDetails
        payload['isAjax'] = true;
        payload['Platform'] = 'web';
        payload['source'] = 'iosApp';
        payload['forBse'] = true;
        payload['email'] = store.getState().user.userDetails.info.email;

        let _url = "/cvlKyc/saveKycForm";
        let requestOptions = middlewareConstants.requestWithCredentialsJsonBSE;
        requestOptions.body = JSON.stringify(payload);

        middlewareService.servicePost(process.env.REACT_APP_API_URL+ _url, requestOptions)
        .then(portfolioResponse => {
          if (!portfolioResponse.success) {
            return toast.error(portfolioResponse.error || "something went wrong!");
          }
          this.props.redirectTo(
            '/add-bank/verify',
            { 
              isBseFlow:true,
              bseFormKycINcomplete: true,
              createClient: true,
              instantFromOutside: this.props.instantFromOutside,
              dashboardtToTrack: true,
              fromUserState: isFromUserState,
              bankAdded: bankAdded === "bankAdded"
            }
          );
          return portfolioResponse;
        });

        // let payload = this.state.kycDetails
        // payload['isAjax'] = true;
        // payload['Platform'] = 'web';
        // payload['source'] = 'iosApp';
        // payload['forBse'] = true;
        // payload['email'] = store.getState().user.userDetails.info.email

        // const requestOptions = {
        //   method: 'POST',
        //   credentials: 'include',
        //   body: JSON.stringify(payload),
        //   headers: {
        //     'Content-Type': 'application/json; charset=UTF-8'
        //   },
        // };

        // return fetch(process.env.REACT_APP_API_URL + '/app/v1/customerDashboard/profile/applyNewCan2', requestOptions)
        //   .then(response => response.json())
        //   .then(result => {
        //    const portfolioResponse = utils.parsePayload(result);
        //     this.controlChildModal();
        //     toast(portfolioResponse.status.userMessage)
        //     return portfolioResponse;
        //   })
        //   .catch(err => console.log(err));
      }

      else {
        onboardingService.uploadKycDetails(this.state.kycDetails)
          .then(response => {
            toast(response.status.userMessage || "datails submitted");
            this.setState({
              goToDocs: true
            })
          })
          .catch(error => {
            console.log("Error occured", error);
          });
      }
    }

    this.setState({
      currentStep: nextStep
    });

    return toast.success("Saved!", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: true
    });
  }

  setCurrentStep(step) {
    let data = store.getState().onboarding.kycDetails;
    this.controlChildModal();
    if (step === 'personalDetails') {
      this.setState({
        currentStep: step
      })
    } else if (step === 'residence') {
      this.setState({
        currentStep: step
      })
    } else if (step === 'misc') {
      this.setState({
        currentStep: step
      })
    } else {
      this.setState({
        currentStep: step
      })
    }
  }

  areAllStepsCompleted() {
    return (
      (this.state.personalDetails && Object.keys(this.state.personalDetails) > 0) &&
      (this.state.residence && Object.keys(this.state.residence) > 0) &&
      (this.state.misc && Object.keys(this.state.misc) > 0)
    );
  }

  controlChildModal = () => {
    this.setState({
      childModal: !this.state.childModal
    });
  }

  kycDetailsSubmittion = () => {
    toast.success("Successfully submitted data!!");
    let isFromUserState = store.getState().onboarding && store.getState().onboarding.addPan && store.getState().onboarding.addPan.fromUserState
    let bankAdded = store.getState().userState  && store.getState().userState.nextUserState 
    this.props.redirectTo(
      '/add-bank/verify',
      {
        isBseFlow: true,
        bseFormKycINcomplete: true,
        redirectLocation: this.props.redirectLocation || "",
        dashboardtToTrack: true,
        fromUserState: isFromUserState,
        bankAdded: bankAdded === "bankAdded"
      }
    );
    this.setState({
      submitKycDetails: true
    });
  }

  render() {
    return (
      <div className="">
        {this.state.isLoading ? (
          <div className="p-4 mb-4">Fetching your application...</div>
        ) : (
          <div className="p-lg-6 px-6 justify-content-center">
            <Row className="justify-content-center">
              <Col xs="12">
                <h2 style ={{fontSize:"20px"}}className="font-weight-semi-bold font-size-triple pb-4">
                Your KYC is not verified. To start investing please verify your KYC.
                </h2>
                <p>
                You can reach out to us at connect@orowealth.com or call us at +919167451886. We will be more than happy to help you."
                </p>
              </Col>
            </Row>
            {/* <div
              className={classnames(
                "border-1 border-bottom cursor-pointer pt-3 pb-3",
                {
                  "border-primary text-primary":
                    this.state.currentStep == "personalDetails",
                }
              )}
              onClick={() => this.setCurrentStep("personalDetails")}
            >
              <i
                className={classnames(
                  "mdi mdi-check-circle pr-3",
                  { "text-primary": this.state.personalDetails.isSubmitted },
                  { "text-muted": !this.state.personalDetails.isSubmitted }
                )}
              />
              Your personal details
            </div> */}

            {/* <div
              className={classnames(
                "border-1 border-bottom cursor-pointer pt-3 pb-3",
                {
                  "border-primary text-primary":
                    this.state.currentStep == "residence",
                }
              )}
              onClick={() => this.setCurrentStep("residence")}
            >
              <i
                className={classnames(
                  "mdi mdi-check-circle pr-3",
                  { "text-primary": this.state.residence.isSubmitted },
                  { "text-muted": !this.state.residence.isSubmitted }
                )}
              />
              Residence
            </div> */}

            {/* <div
              className={classnames(
                "border-1 border-bottom cursor-pointer pt-3 pb-3",
                {
                  "border-primary text-primary":
                    this.state.currentStep == "misc",
                }
              )}
              onClick={() => this.setCurrentStep("misc")}
            >
              <i
                className={classnames(
                  "mdi mdi-check-circle pr-3",
                  { "text-primary": this.state.misc.isSubmitted },
                  { "text-muted": !this.state.misc.isSubmitted }
                )}
              />
              Miscellaneous
            </div> */}

            {/* <div
              className={classnames(
                "border-1 border-bottom cursor-pointer pt-3 pb-3 d-none",
                {
                  "border-primary text-primary":
                    this.state.currentStep == "docs",
                }
              )}
              onClick={() => this.setCurrentStep("docs")}
            >
              <i
                className={classnames("mdi mdi-check-circle pr-3 text-muted", {
                  "text-primary":
                    this.state.docs && Object.keys(this.state.docs) > 0,
                })}
              />
              Upload your Documents
            </div> */}

            {/* <div className="text-center">
              <ButtonWithLoader
                text="Submit"
                isLoading={this.state.submitting}
                className="w-75 my-5"
                color="primary"
                onClick={() => this.kycDetailsSubmittion()}
                disabled={
                  !this.state.personalDetails.isSubmitted ||
                  !this.state.misc.isSubmitted ||
                  !this.state.residence.isSubmitted
                }
              />
            </div> */}
          </div>
        )}

        {/* <Modal
          isOpen={this.state.childModal}
          toggle={this.controlChildModal}
          className={classnames("modal-md onboarding-modal w-100", {
            "h-100":
              this.state.currentStep == "residence" ||
              this.state.currentStep == "personalDetails" ||
              this.state.currentStep == "misc",
          })}
          backdrop={"static"}
          keyboard={true}
        >
          <ModalHeader toggle={this.controlChildModal}></ModalHeader>
          <ModalBody>
            {this.state.currentStep === "personalDetails" ? (
              <div className="px-4">
                <h2 className="font-weight-semi-bold font-size-triple pb-4">
                  Your personal details
                </h2>
                <PersonalDetailsForm
                  submit={this.setKycDetails}
                  data={this.state.personalDetails}
                />
              </div>
            ) : (
              ""
            )}

            {this.state.currentStep === "residence" ? (
              <div className="px-4">
                <h2 className="font-weight-semi-bold font-size-triple pb-4">
                  Residence
                </h2>
                <ResidenceDetailsForm
                  submit={this.setKycDetails}
                  data={this.state.residence}
                  hasCPDEntry={
                    store.getState().user.userDetails &&
                    store.getState().user.userDetails.cpd[0].CPD &&
                    store.getState().user.userDetails.cpd[0].CPD.length
                  }
                  isBseUser={
                    store.getState().bse && store.getState().bse.hasBseAccount
                  }
                  bseVsMfu={Helpers.isCpdForMfuOrBse(
                    store.getState().user.userDetails &&
                      store.getState().user.userDetails.cpd[0].CPD,
                    store.getState().bse && store.getState().bse.hasBseAccount
                  )}
                />
              </div>
            ) : (
              ""
            )}

            {this.state.currentStep === "misc" ? (
              <div className="px-4">
                <h2 className="font-weight-semi-bold font-size-triple pb-4">
                  Miscellaneous
                </h2>
                <MiscDetailsForm
                  submit={this.setKycDetails}
                  pan={this.props.pan}
                  dob={this.props.dob}
                  email={this.props.email}
                  data={this.state.misc}
                />
              </div>
            ) : (
              ""
            )}

            {this.state.currentStep === "docs" && !this.state.goToDocs ? (
              <div className="h-100 text-center">
                <b>Checking Data...</b>
                <OroLoaderInline />
              </div>
            ) : (
              ""
            )}

            {this.state.currentStep === "docs" && this.state.goToDocs ? (
              <div className="px-4">
                <UploadDocs
                  onComplete={() => this.props.onComplete(this.props.stepName)}
                  stepName="docs"
                  pan={store.getState().onboarding.pan}
                  email={store.getState().user.userDetails.info.email}
                  showHeader={true}
                />
              </div>
            ) : (
              ""
            )}
          </ModalBody>
        </Modal> */}
      </div>
    );
  }
}

export default BseKycIncomplete; 